import { render, staticRenderFns } from "./_addoredit_areagroup.vue?vue&type=template&id=750aab43&"
import script from "./_addoredit_areagroup.vue?vue&type=script&lang=js&"
export * from "./_addoredit_areagroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports